import isEqualBounds from './is-equal-bounds';
import isElementColumn from '../../blocks/helpers/is-element-column';

const isSingleFullWidthColumnInWidget = (element) => {
  if (!isElementColumn(element)) return false;

  const columnsWidget = element.closest('ws-block[widget="columns"]');

  if (!columnsWidget) return false;

  const columnsContainer = columnsWidget.querySelector('ws-columns');

  if (!columnsContainer) return false;

  const columns = columnsContainer.querySelectorAll(':scope > ws-column');

  if (columns.length !== 1) return false;

  const elementBounds = element.getBoundingClientRect();
  const columnBounds = columns[0].getBoundingClientRect();

  return isEqualBounds(elementBounds, columnBounds);
};

export default isSingleFullWidthColumnInWidget;
